import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Home from './pages/home';
import Signup from './pages/signup';
import Login from './pages/login';
import { useState } from 'react';
import RefreshHandler from './refreshHandler';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  
  const PrivateRoute = ({element})=>{
    return isAuthenticated ? element : <Navigate to='/login'/>
  }
  return (
    <div className="App">
      <RefreshHandler setIsAuthenticated={setIsAuthenticated}/>
      <Routes>
        <Route path="/home" element={<PrivateRoute element={<Home />} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login"></Navigate>} />
      </Routes>
    </div>
  );
}

export default App;
